module.exports = __webpack_public_path__ + "img/REINDEER.9eaf4c5.svg";